import styled from "styled-components";
import { Button, Grid, Typography } from "@material-ui/core";
import theme from "@src/Tools/MuiTheme";

export const STForm = styled.form`
  min-height: 200px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 15px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const STButton = styled(Button)`
  && {
    margin-top: 25px;
  }
`;

export const STCompleteButtonGrid = styled(Grid)`
  && {
    display: flex;
    justify-content: flex-end;
  }
`;

export const STHeader = styled(Typography)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;

  &&& {
    ${theme.breakpoints.up("sm")} {
      font-size: 1.25rem;
    }

    ${theme.breakpoints.only("xs")} {
      font-size: 1.05rem;
    }

    :hover {
      cursor: pointer;
    }
  }
`;

export const STText = styled(Typography)`
  text-overflow: ellipsis;
  overflow-x: hidden;
  &&& {
    ${theme.breakpoints.up("sm")} {
      padding-bottom: 1.25rem;
      font-size: 0.9rem;
    }

    ${theme.breakpoints.only("xs")} {
      padding-bottom: 1.05rem;
      font-size: 0.7rem;
    }

    :hover {
      cursor: pointer;
    }
  }
`;
